<div class="form-floating">
  <input #autocompleteInput type="text"
    [class.is-invalid]="!isLoadingContent() && (!hasDeliveryAddressCoverage() && isGoogleAddressFilled())"
    [class.is-valid]="!isLoadingContent() && hasDeliveryAddressCoverage()" class="form-control" id="address"
    (input)="changeAddress()" placeholder [(ngModel)]="queryString">
  <label for="address">Please enter your delivery address</label>
  @if (isLoadingContent()) {
  <mat-progress-bar mode="indeterminate" value="accent"></mat-progress-bar>
  } @else {
  @if (hasDeliveryAddressCoverage()) {
  <div class="valid-tooltip right-0">
    This address is in our delivery area!
  </div>
  } @else if (isGoogleAddressFilled()) {
  <div class="invalid-tooltip right-0">
    Oops! Your address isn't in our delivery zone.
  </div>
  }
  }
</div>

<div class="d-grid gap-2 col-md-6 mx-auto mt-5">
  <button type="button" class="btn btn-primary" (click)="checkDeliveryAddressCoverage()">Check address</button>
  <small class="text-center mt-4">Already have an account?</small>
  <button type="button" class="btn btn-outline-primary" (click)="loginClickHandler()">Log in</button>
  <small class="text-center">
    <p>Don't have an account? <a href="/signup">Sign up here</a></p>
  </small>
</div>